module.exports = __webpack_public_path__ + "img/moby_reprise.b623f711.jpg";